module.exports = __webpack_public_path__ + "static/media/girl-4181395_960_720.818afd17.jpg";